const messageLevels = {
	ERROR: "error",
	INFO: "info",
	SUCCESS: "success"
} as const;

export type MessageLevel = typeof messageLevels[keyof typeof messageLevels];

export default messageLevels;
